import React, { Fragment } from 'react';
import { common } from '@kurtosys/ksys-app-template';
import { computed, makeObservable } from 'mobx';
import { observer } from 'mobx-react';

import { ComponentBase } from '../../../shared/ComponentBase.js';
import { InjectedStyledComponent } from '../../../shared/InjectedStyledComponent.js';
import { ITranslationContextValue } from '../../base/Translate/models/ITranslationContextValue.js';
import Translate, { TranslationContext } from '../../base/Translate/Translate.js';

import { IAwardConfiguration, IAwardProps, IAwardState } from './models/index.js';
import AwardImage from './styledComponents/AwardImage.js';
import Description from './styledComponents/Description.js';
import ImageWrapper from './styledComponents/ImageWrapper.js';
import Name from './styledComponents/Name.js';
import Wrapper from './styledComponents/Wrapper.js';
import { AWARD_CATEGORY_KEY, AWARD_COMPONENT_KEY } from './Award.meta.js';

export class Award extends ComponentBase<IAwardProps, IAwardState, IAwardConfiguration> {
	categoryKey = AWARD_CATEGORY_KEY;
	componentKey = AWARD_COMPONENT_KEY;

	translationContext: ITranslationContextValue | undefined;

	constructor(props: IAwardProps) {
		super(props);

		makeObservable(this, {
			Image: computed,
			Name: computed,
			Description: computed,
			nameFirst: computed,
		});
	}

	get Image() {
		const { photoSrc } = this.props;
		let { imageProps } = this.props;
		if (photoSrc) {
			if (imageProps) {
				imageProps.src = photoSrc;
			} else {
				imageProps = { src: photoSrc };
			}
		}
		return (
			<ImageWrapper>
				<AwardImage {...imageProps} />
			</ImageWrapper>
		);
	}

	get Name() {
		const { name } = this.props;
		return (
			!common.commonUtils.isNullOrEmpty(name) && (
				<Name>
					<Translate>{name}</Translate>
				</Name>
			)
		);
	}

	get Description() {
		const { description, textProps } = this.props;
		if (!common.commonUtils.isNullOrEmpty(description)) {
			const descriptionProps = {
				...textProps,
				value: description,
			};
			return <Description {...descriptionProps} />;
		}
	}

	get nameFirst(): boolean {
		const { layout } = this.props;
		return layout === 'name-first';
	}

	render() {
		const { className } = this.props;
		let groupLabel = 'Awards';
		if (this.translationContext) {
			groupLabel = this.translationContext.translate(groupLabel);
		}
		return (
			<Fragment>
				<TranslationContext.Consumer>
					{(translationContext) => {
						this.translationContext = translationContext;
						return null;
					}}
				</TranslationContext.Consumer>
				<Wrapper className={className} role="group" aria-label={groupLabel}>
					{this.nameFirst && this.Name}
					{this.Image}
					{!this.nameFirst && this.Name}
					{this.Description}
				</Wrapper>
			</Fragment>
		);
	}
}

export default InjectedStyledComponent(observer(Award), AWARD_CATEGORY_KEY, AWARD_COMPONENT_KEY);
